
export let settings = {
    dataPath: "/data/properties_1.6.json"
}

// The data file is served from S3 with no cache-control headers, so the browser
// (and any CDN in front of it) will happily serve a stale listing after a deploy.
// Bust it on every request: no-store covers the HTTP cache, the timestamp param
// covers anything that ignores it.
export const fetchData = (): Promise<Response> =>
    fetch(`${settings.dataPath}?t=${Date.now()}`, {
        cache: "no-store",
        headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            "Pragma": "no-cache"
        }
    });

export type Address = {
    addressLine1: string,
    addressLine2: string,
    city: string,
    stateCode: string,
    zip: string
}


export type Property = {
    id: string,
    lat: number,
    lng: number,
    name: string,
    address: Address
}

export type Unit = {
    id: number,
    name: string,
    address: Address,
    propertyId: number,
    addressLine1: string,
    city: string,
    state: string,
    zip: string,
    sqft: number,
    dimensions: string,
    notes: string,
    status: string,
    perSqftRate: number,
    perMonthRate: number,
    images: string[],
    thumbnail: string
}

